/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2022-11-19 13:45:00
 * @LastEditors: Please set LastEditors
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { reducerStates } from 'root/store/types';
import messages from './messages';
import styles from './index.less';

const ChangeDeployment = () => {
  const intl = useIntl();
  const { cluster, isSuposInstalled } = useSelector((state: reducerStates) => state.envManage);
  const navigate = useNavigate();

  const jumpTo = () => {
    if (isSuposInstalled) return;
    navigate('/inductive');
  };

  const type = cluster ? intl.formatMessage(messages.colony) : intl.formatMessage(messages.alone);

  return (
    <div className={styles.change_model_tip}>
      {intl.formatMessage(messages.deploymentMode, { type })}“
      <span style={{ color: isSuposInstalled ? '#646E79' : '#2280FA' }} onClick={jumpTo}>
        {intl.formatMessage(messages.change)}
      </span>
      ”
    </div>
  );
};

export default ChangeDeployment;
